"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getEmbedUrl = void 0;
const urlParser_1 = __importDefault(require("root/src/shared/util/urlParser"));
const platforms_1 = require("root/src/shared/@types/platforms");
const qs_1 = require("qs");
const cfOutput_1 = __importDefault(require("root/cfOutput"));
const language_service_1 = require("root/src/client/v2/common/helpers/language.service");
const { domainName } = cfOutput_1.default;
const getEmbedUrl = (url, { muted, autoplay } = {}) => {
    const parsedUrl = (0, urlParser_1.default)(url);
    if (!parsedUrl)
        return '';
    const languageCode = language_service_1.LanguageService.getDomainPrefixCode(window.location.host);
    const queryBase = {
        autoplay: true,
        parent: languageCode ? `${languageCode}.${domainName}` : domainName,
    };
    const twitchQueryBase = {
        muted,
        autoplay,
    };
    const { id, provider, mediaType } = parsedUrl;
    if (provider === platforms_1.Platform.Twitch && mediaType === 'clip') {
        const query = (0, qs_1.stringify)(Object.assign(Object.assign(Object.assign({}, queryBase), twitchQueryBase), { clip: id }));
        return `https://clips.twitch.tv/embed?${query}`;
    }
    if (provider === platforms_1.Platform.Twitch && mediaType === 'video') {
        const query = (0, qs_1.stringify)(Object.assign(Object.assign(Object.assign({}, queryBase), twitchQueryBase), { video: `v${id}` }));
        return `https://player.twitch.tv?${query}`;
    }
    if (provider === platforms_1.Platform.YouTube
        && (mediaType === 'video' || mediaType === 'shorts')) {
        const query = (0, qs_1.stringify)(Object.assign(Object.assign({}, queryBase), { autoplay: 1, 
            // there has to be mute, otherwise autoplay doesn't works
            mute: 1 }));
        return `https://www.youtube.com/embed/${id}?${query}`;
    }
    if (provider === platforms_1.Platform.TikTok && (mediaType === 'video')) {
        const query = (0, qs_1.stringify)(Object.assign({}, queryBase));
        return `https://www.tiktok.com/player/v1/${id}?${query}`;
    }
    return '';
};
exports.getEmbedUrl = getEmbedUrl;
